module.exports = {
  choose_metric: 'Выберите метрику',
  choose_condition: 'Выберите условие',
  filter_placeholder: 'Начните вводить значение метрики …'
}
